/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/15/19
 * Time: 3:05 PM
 */
import React, {Component, createRef} from 'react';
import {MDBModalBody, MDBModalHeader} from "mdbreact";
import QrReader from 'react-qr-reader'
import './ScanQR.css'
import { Input} from "semantic-ui-react";
import {Col, Row} from "reactstrap";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";

class App extends Component {
  state = {
    result: null,
    ref_code: ''
  };

  toggle = () => {
  };

  handleScan = data => {
    if (data) this.props.sendToReceptionist(data);
  };
  handleError = err => {
    console.error(err)
  };
  inputRefCode1 = createRef();
  componentDidMount() {
    this.inputRefCode1.current.focus();
  }
  handleChange = name => event => {
    clearTimeout(this.timeout);
    let value = event.target.value;
    let onlyDigit = new RegExp("^\\d+$");
    if (onlyDigit.test(value) || value.length === 0) {
      this.setState({ref_code: value.trim()})
      if(value.trim().length > 10){
        this.timeout = setTimeout(()=>{
          this.props.sendToReceptionist(value.trim());
        }, 1000);
      }
    }
  };
  render() {
    return (
      <div className={"qr-scan-modal-wrapper"}>
            <div isOpen={true} toggle={this.toggle} size="md" className={"qr-scan-modal"}>
              <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Scan Mobile QR Code</MDBModalHeader>

              <MDBModalBody style={{padding: '0px'}}>
                <Row>
                  <Col xs={12}>
                    <Input
                      ref={this.inputRefCode1}
                      focus={true}
                      className={"ref-qr-input w-100"}
                      placeholder=''
                      value={this.state.ref_code}
                      onChange={this.handleChange('ref_code')}
                    />
                  </Col>

                </Row>
                <QrReader
                  delay={300}
                  onError={this.handleError}
                  onScan={this.handleScan}
                  style={{width: '100%'}}
                />
              </MDBModalBody>
            </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  all_available_card: state.reception_SheduleMeetingReducer.all_available_card,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
